module.exports = __webpack_public_path__ + "static/Image09@2x-1da167edb1448c8ba22e5b2c410d586b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image09@2x.jpg
// module id = 902
// module chunks = 227233210825294 244429959259914